module.exports = __webpack_public_path__ + "img/6.4ebe30d8.jpg";